import React from 'react'
import styled from 'styled-components'
import {GIFT_SHOP_HEADER_HEIGHT, POLICY_ROOT_MENU_WIDTH_MOBILE} from 'consts'
import {useTranslation} from 'i18n'
import {getThemeColor, getWebBaseUrl, useHistory} from 'utils'
import {useWindowMode} from 'windows'
import {Icon, Modal, Paragraph} from 'common/components'
import convertUnit from 'lib/unit'
import {PolicyRootTopNavBarItem} from '../TopNavBarItem'
import {PolicyRootBottomNavBarProps} from './PolicyTopNavBarProps'

interface ContainerProps {
  expand?: boolean
}
const StyledSectionNavBar = styled.div`
  display: flex;
  height: ${convertUnit(64)};
  align-items: center;
  border-bottom: ${convertUnit(1)} solid ${({theme}) => theme.white_5};
`

const StyledMenu = styled.div<ContainerProps>`
  display: flex;
  width: ${convertUnit(POLICY_ROOT_MENU_WIDTH_MOBILE)};
  min-height: ${convertUnit(GIFT_SHOP_HEADER_HEIGHT)};
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-right: ${({expand, theme}) =>
    !expand ? `${convertUnit(1)} solid ${theme.white_5}` : undefined};
`

const StyledMenuDetail = styled.div`
  display: flex;
  flex-direction: column;
`

const StyledHeaderTitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: ${convertUnit(20)};
  gap: ${convertUnit(20)};
`
const StyledIconContainer = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  -webkit-tap-highlight-color: transparent;
  -webkit-tap-highlight-color: ${({theme}) =>
    getThemeColor(theme, 'white_1', 0)};
`

const StyledSeparator = styled.div`
  height: ${convertUnit(1)};
  width: 90%;
  background-color: ${({theme}) => theme.white_5};
`
const StyledListItemContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  max-width: ${convertUnit(POLICY_ROOT_MENU_WIDTH_MOBILE)};
`
const StyledModal = styled(Modal)`
  position: absolute;
  display: flex;
  flex-direction: column;
  left: 0;
  height: 100%;
  border-radius: 0;
`
const StyledScrollContainer = styled.div`
  overflow-y: scroll;
  overflow-x: hidden;
  ::-webkit-scrollbar {
    background-color: ${({theme}) => theme.white_3};
    width: ${convertUnit(0)};
  }
  ::-webkit-scrollbar-thumb {
    background-color: ${({theme}) => theme.primary_5};
    background-clip: content-box;
    border-radius: ${convertUnit(0)};
  }
`

export default function GiftShopRootBottomNavBar({
  expand,
  onExpand,
  data,
  select,
}: PolicyRootBottomNavBarProps) {
  const history = useHistory()
  const mode = useWindowMode()
  const {translate} = useTranslation()

  return (
    <>
      <StyledMenuDetail>
        <StyledSectionNavBar>
          <StyledMenu onClick={onExpand} expand={expand}>
            <Icon size={20} type="menu" color="gray_5" />
          </StyledMenu>
          <StyledHeaderTitleContainer>
            <StyledIconContainer>
              <Icon
                className="pressable"
                type="back"
                color="primary_5"
                onClick={() => {
                  // go back to mobile app's previous screen if this page is open in mobile app's webview.
                  if (window.ReactNativeWebView) {
                    window.ReactNativeWebView.postMessage('back')
                  } else if (window.opener) {
                    // handle back if this page is open by iframe.
                    window.opener.postMessage('back', getWebBaseUrl())
                  } else {
                    history.push('giftshop_feed', {})
                  }
                }}
              />
            </StyledIconContainer>
            <Paragraph fontSize="l" fontWeight="medium">
              {translate('global:howItWorks')}
            </Paragraph>
          </StyledHeaderTitleContainer>
        </StyledSectionNavBar>
        <StyledModal visible={!!expand} onBackdropPress={onExpand}>
          <StyledMenu onClick={onExpand} expand={expand}>
            <Icon size={20} type="menu" color="gray_5" />
          </StyledMenu>
          <StyledSeparator />
          <StyledScrollContainer>
            {data.map(({key, label, onClick}) => (
              <StyledListItemContainer key={key}>
                {key === 'how-it-works' || mode === 'website' ? null : (
                  <StyledSeparator />
                )}
                <PolicyRootTopNavBarItem
                  label={label}
                  isSelected={select === key}
                  onClick={() => {
                    onExpand()
                    onClick()
                  }}
                />
              </StyledListItemContainer>
            ))}
          </StyledScrollContainer>
        </StyledModal>
      </StyledMenuDetail>
    </>
  )
}
